<template>
  <div>
    <!-- TODO 一旦作らない -->
    見積もり書・明細書
  </div>
</template>

<script>
export default {
  name: 'EstimateSpecification',
  props: {
    settingValue: {}
  }
}

</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/main/js/components/sheet/EstimateSpecification.vue